import { ApiResponse } from "./../models/api.model";
import { Referee } from "./../models/referee.model";
import axios from "./axios";

export default {
  getReferees() {
    return axios.get().get<ApiResponse<Referee[]>>(`/referees`);
  }
};
